import apiService from '@udacity/ureact-api-service';
import CONFIG from 'configLoader';

export function upload(body) {
  /*
   body consists of an object:
   {
     fileName: string,
     fileType: string,
     image: dataURL base64 from FileReader
   }
  */
  return apiService.makePostRequest(CONFIG.mentorApiUrl, '/images/upload', body);
}
